// export const API_BASE_URL = 'http://localhost:5555/api/v1'
export const API_BASE_URL = 'https://italianyapi.iosx.in/api/v1'